<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="witnessSignatureData"
    />

    <SignaturePad
      :showSignaturePad="showSignaturePad1"
      @close="showSignaturePad1 = false"
      @signatureData="employeeSignatureData"
    />

    <v-card class="card-height">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-md-caption">
          For good consideration and as an inducement for {{ userCompany }}-UT
          LLC., to employ
          <b>
            <span class="text-decoration-underline text-uppercase">
              {{ user.Name }}
            </span></b
          >, the undersigned employee hereby agrees not to directly or
          indirectly solicit clients with the business of {{ userCompany }}-UT
          LLC. and its successors and assigns during the period of employment
          and for a period of 1 year following termination of employment and
          notwithstanding the cause or reason for termination
        </p>

        <p class="text-md-caption">
          The employee acknowledges that {{ userCompany }}-UT LLC. shall or may
          in reliance of this agreement provide employee access to trade
          secrets, customers, clients’ families or legal guardians and other
          confidential data and good will. Employee agrees to retain said
          information as confidential and not to use said information on his or
          her own behalf or disclose same to any third party
        </p>

        <p class="text-md-caption">
          This agreement shall be binding upon and inure to the benefit of the
          parties, their successors, assigns, and personal representatives
        </p>
      </v-col>

      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee Signature"
                @click.stop="showSignaturePad1 = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignature"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="employeeDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSignedEmployee"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSignedEmployee"
                @input="employeeDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.witnessName"
              label="Witness Name (print) "
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Witness Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="witnessSignature"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="witnessDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSignedWitness"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSignedWitness"
                @input="witnessDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn color="" @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import SignaturePad from "@/components/SignaturePad";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      employeeDateMenu: false,
      witnessDateMenu: false,
      item: {},
      witnessSignature: "",
      employeeSignature: "",
      showSignaturePad: false,
      showSignaturePad1: false,
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),

    witnessSignatureData(data) {
      this.witnessSignature = data;
    },

    employeeSignatureData(data) {
      this.employeeSignature = data;
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "non-solicitation-agreement",
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    prev() {
      this.$emit("clicked", this.step - 1);
    },

    async populateUserInfo() {
      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.NonSolicitationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
          signedDate: moment(documents.signedDate).format("YYYY-MM-DD"),
          dateSignedEmployee: moment(documents.dateSignedEmployee).format("YYYY-MM-DD"),
          dateSignedWitness: moment(documents.dateSignedEmployee).format("YYYY-MM-DD"),
          witnessSignedDate: moment(documents.witnessSignedDate).format(
            "YYYY-MM-DD"
          ),
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "non-solicitation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(pdfFile, "non-solicitation-agreement.pdf", "application/pdf");
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.v-stepper__content {
  top: 0;
  padding: 0 !important;
  flex: 1 0 auto;
  width: 100%;
}

.education--training {
  position: relative;
}

.employment--history {
  position: relative;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}

.card-height {
  min-height: 40vh;
}
</style>
